<div mdbModal #modal="mdbModal" class="modal fade" id="modal" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-notify modal-danger modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <div class="text-center">
          <i class="fa fa-trash fa-4x mb-3 animated rotateIn"></i>
          <p [translate]="message" [translateParams]="messageParams"></p>
        </div>
      </div>
      <div class="modal-footer justify-content-center">
        <a type="button" mdbBtn color="danger" class="waves-effect" (click)="confirm()" mdbWavesEffect>
          <i class="fa fa-check mr-1 white-text"></i>
          {{ confirmLabel | translate}}
        </a>
        <a type="button" mdbBtn color="danger" outline="true" class="waves-effect" mdbWavesEffect (click)="close()">
          <i class="fa fa-close mr-1"></i>
          {{ cancelLabel | translate}}
        </a>
      </div>
    </div>
  </div>
</div>
